// extracted by mini-css-extract-plugin
module.exports = {"commentsList":"CommentsList_commentsList__1YExj"};